import queryString from 'query-string';

export default (params) => {
  try {
    return queryString.parse(params);
  } catch (e) {
    return {};
  }
};
